import styled from "styled-components"

const SectionAction =  styled.div`
  text-align: center;
  padding-bottom: 12rem;
`

export default SectionAction
